module.exports = __webpack_public_path__ + "media/src/img/payment/qiwi-logo-2c11ba86b2c1a11be77d15c30221f9af.svg";